import React, { useContext, useReducer, useCallback, useEffect } from "react"
import { useHistory } from "react-router-dom"
import axios from "axios"
import { useTranslation } from "react-i18next"

import { CircularProgress } from '@material-ui/core'
import Pagination from "@material-ui/lab/Pagination"

import ErrorBoundary from '../../Utils/ErrorBoundary'
import AuthContext from "../../../context/auth-context"
import { useStateConnectedToCache, dataFetchReducer } from "../../Utils/requestUtils"
import Filter from "./Filter/Filter"
import RegistrationDataValidationCard from "./RegistrationDataValidationCard/RegistrationDataValidationCard"

function RegistrationDataValidationInbox(props) {
    const { t } = useTranslation()
    const history = useHistory()
    const user_data = useContext(AuthContext).user_data

    if (!user_data.roles.includes("read_registration_data_validations")) {
        history.push("")
    }

    let local_storage_object_preffix = "registrationDataValidation"

    const [pageParams, setPageParams] = useStateConnectedToCache(local_storage_object_preffix)

    const [pageState, dispatchPageState] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const doRequest = useCallback(
        (payload) => {
            dispatchPageState({ type: "data_fetch_init" })
            axios.get("/dash/account_event/registration_data_validations", {
                params: payload
            }).then(response => {
                dispatchPageState({
                    type: "data_fetch_success",
                    payload: response.data
                })
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchPageState({ type: "data_fetch_failure_403" })
                else if ((error.response || {}).status === 404) dispatchPageState({ type: "data_fetch_failure_404" })
                else dispatchPageState({ type: "data_fetch_failure" })
            })
        }, []
    )

    useEffect(() => {
        let payload = {
            "page_number": pageParams.page - 1,
            "page_rows": 15
        }
        Object.keys(pageParams.filters).forEach((key, index) => {
            payload[key] = pageParams.filters[key]
        })
        const timer_ = setTimeout(() => {
            doRequest(payload, false)
        }, 300);
        const timer_2 = setInterval(() => {
            doRequest(payload, true)
        }, 60000);
        return () => {
            clearTimeout(timer_)
            clearInterval(timer_2)
        }
    }, [doRequest, pageParams])

    const handleChangePage = (event, page, filters) => {
        if (pageState.page === page) {
            return
        }
        setPageParams({ page: page, filters: filters })
    }

    const contentContainer = (dataList) => {
        let itensCount = dataList['data'].length

        if (itensCount === 0) {
            return (
                <div className='emptyContainer'>
                    <p className={["blueText", "subtitleSize"].join(" ")}>
                        {t("Nenhum evento a ser registrado")}
                    </p>
                </div>
            )
        }
        else {
            let cards = dataList['data'].map((registration_data_validation) => (
                <ErrorBoundary key={registration_data_validation.id}>
                    <RegistrationDataValidationCard registration_data_validation={registration_data_validation} />
                </ErrorBoundary>
            ))

            return (
                <div className='cardContainer'>
                    <div className="listCardHeader">
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "2 1 120px", textAlign: "center" }}
                        >
                            ID
                        </div>
                        {user_data.business_group_key &&
                            <div
                                className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                                style={{ flex: "2 1 200px", textAlign: "center" }}
                            >
                                Cliente
                            </div>}
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 145px", textAlign: "center" }}
                        >
                            Documento
                        </div>
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 45px", textAlign: "center" }}
                        >
                            Status
                        </div>
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 110px", textAlign: "center" }}
                        >
                            Data de Análise
                        </div>
                    </div>
                    {cards}
                </div>
            )
        }
    }

    if (pageState.fetchedData) {
        return (
            <div style={{ width: "auto", paddingBottom: "30px" }}>
                <div style={{ display: "flex" }}>
                    <div >
                        <p className={["blueText", "titleSize"].join(" ")}>{t("VALIDAÇÕES DE DADOS CADASTRAIS")}</p>
                    </div>
                </div>

                <div>{contentContainer(pageState.fetchedData)}</div>
                <div>
                    <Pagination
                        className="pagination"
                        page={pageParams.page}
                        count={parseInt(pageState.fetchedData["number_of_pages"])}
                        onChange={(e, page) => handleChangePage(e, page, pageParams.filters)}
                    />
                </div>
            </div>
        )
    }

    else if (pageState.isError) {
        return (
            <div style={{ width: "auto" }}>
                <p className={["blueText", "titleSize"].join(" ")}>{t("VALIDAÇÕES DE DADOS CADASTRAIS")}</p>
                <ErrorBoundary doNothing><Filter local_storage_object_preffix={local_storage_object_preffix} setPageParams={setPageParams} /></ErrorBoundary>
                <div style={{ height: "55vh", display: "flex" }}>
                    <p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
                        {pageState.errorMessage}
                    </p>
                </div>
            </div>
        )
    }

    else if (pageState.isLoading) {
        return (
            <div style={{ width: "auto" }}>
                <p className={["blueText", "titleSize"].join(" ")}>{t("CADASTROS DE PESSOA FÍSICA")}</p>
                <div className="circularProgressCenter">
                    <CircularProgress />
                </div>
            </div>
        )
    }

    return <div>
        account event
    </div>
}

export default RegistrationDataValidationInbox;